import AOS from '../utils/aos.js';

AOS.init({
    duration: 800,
    useClassNames: true,
    once: true,
    easing: 'ease'
});